// extracted by mini-css-extract-plugin
export default {"loginPage":"Login_loginPage__yP8pi","loginCard":"Login_loginCard__sVKak","button":"Login_button__86uwc"};